import { TableCell, styled } from "@mui/material";

export const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#5f847d !important',
  color: `${theme.palette.common.white} !important`,
  fontWeight: 'bold',
  padding: theme.spacing(1.5, 2),
  fontSize: '0.85rem',
  borderBottom: 'none',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  '& .MuiTableSortLabel-root': {
    color: 'inherit',
    display: 'inline-flex',
    verticalAlign: 'middle',
    marginLeft: 0,
    marginRight: 0,
    paddingLeft: 0,
    paddingRight: 0,
    '&:hover': {
      color: 'inherit',
    },
    '&.Mui-active': {
      color: 'inherit',
    },
    '& .MuiTableSortLabel-icon': {
      display: 'none !important',
    },
  },
}));